export default __webpack_public_path__ + "static/media/Pattern2.a5f17223.png";